import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'itl-error-display',
  templateUrl: './error-display.component.html',
  styleUrls: ['./error-display.component.scss'],
  standalone: false,
})
export class ErrorDisplayComponent {
  @Input()
  public control: AbstractControl;
}
